import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from 'src/app/services/spinner.service';
import { StorageService } from 'src/app/services/storage.service';
import { alertaConfirmacion, basicAlert, basicAlert_Html } from '../../utils';
import { UsuarioService } from 'src/app/services/usuarios.service';
import { SucursalService } from 'src/app/services/sucursal.service';
import { objUsuarioModel, UsuarioPropiedadesFrm } from 'src/app/models/objUsuario.model';
import { iusuario } from './../../../models/iusuario.model';
import { ImagenBase64 } from 'src/app/models/imagenBase64.model';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-md-panel-control-usuario',
  templateUrl: './md-panel-control-usuario.component.html',
  styleUrls: ['./md-panel-control-usuario.component.scss']
})
export class MdPanelControlUsuarioComponent implements OnInit {
  public sessionInfo: any = null;
  sucursales: any[] = [];
  modulos: any = [];
  public codmod: number = null;
  modificarclaveViewUpdate: any;

  //CAMPOS UPDATE
  coduserViewUpdate:any;
  nombresViewUpdate:any;
  cargoViewUpdate:any;
  correoViewUpdate:string = '';
  activoViewUpdate:any;
  activoViewUpdateRespaldo:any;
  codsucViewUpdate:any;
  codvenViewUpdate:any;
  comentarioViewUpdate:any;
  claveactualViewUpdate:string = '';
  claveViewUpdate:string = '';
  claveconfirViewUpdate:string = '';

  tipoItemImageCabecera:number = 1;
  imagenCabecera:any;
  ocultarBotonEliminarCabecera:boolean = false;
  ocultarBotonGuardarCabecera:boolean = true;
  ocultarBotonImagenCabecera:boolean = false;
  objUsuarioModel = new objUsuarioModel();
  
  modulos2:any[] = [];
  size: number;

  fechaExpiracion:any;

  estadoVisivilidad:any = [
    { label: 'NuevaContraseniaInsertar', mostrar: false },
    { label: 'ConfirmarContraseniaInsertar', mostrar: false },
    { label: 'NuevaContraseniaEditar', mostrar: false },
    { label: 'ConfirmarContraseniaEditar', mostrar: false },
    { label: 'ClaveActual', mostrar: false },
  ]
    requisitosContrasena = {
    longitud: false,
    minuscula: false,
    mayuscula: false,
    numero: false,
    especial: false,
    igualdad:false
  };
  empezarEscribir = false;

  @ViewChild('fileUploadCabecera') fileUploadCabecera: ElementRef;
  
  constructor(
    private modalactiveService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private usuarioService: UsuarioService,
    private sucursalService: SucursalService,
    private _sanitizer: DomSanitizer,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.sessionInfo = JSON.parse(StorageService.getSession());
    this.modulos = this.sessionInfo.modulos;
    this.codmod = -1;
    
    if (this.sessionInfo != null) {
      this.getListSucursal();
      this.openUpdate(this.sessionInfo.coduser)
      this.modificarclaveViewUpdate = false;
    }
  }

  _close() {
    this.modalactiveService.dismiss('canceling');
  }
  
  private getListSucursal() {
    this.sucursalService.buscarSucursal().subscribe(response => {
      this.sucursales = response.body;
    })
  }
  
  openUpdate(coduser: string) {
    this.usuarioService.obtener(coduser).subscribe(response => {
      this.coduserViewUpdate = response.body.coduser;
      this.nombresViewUpdate = response.body.nombres;
      this.cargoViewUpdate = response.body.cargo;
      this.activoViewUpdate = response.body.activo;
      this.activoViewUpdateRespaldo = response.body.activo;
      this.codsucViewUpdate = response.body.codsuc;
      this.correoViewUpdate=response.body.email;
      this.codvenViewUpdate = response.body.propiedad.codigoVendedor;
      this.comentarioViewUpdate = response.body.comentario;
      this.fechaExpiracion = response.body.fexpira;
      this.buscarModulos();
      this.obtenerImagen();
      this.spinnerService.activarLoading(false);
    }, err => {      
      alert(err.error)
      this.spinnerService.activarLoading(false);
    })
  }

  buscarModulos(){
      this.usuarioService.buscarModulos(this.coduserViewUpdate,'','').subscribe((resp:any)=>{
        this.modulos2=resp.body;
      },err=>{
        this.modulos2=[];
      })
  }
  
  obtenerImagen(){
    this.spinnerService.activarLoading(true)
    this.usuarioService.obtenerFirma_v2(this.sessionInfo.id_cia,this.coduserViewUpdate,this.tipoItemImageCabecera).subscribe((response: any) => {
      if(response.body==null){
        this.imagenCabecera = '';
        this.ocultarBotonEliminarCabecera = false;
        this.ocultarBotonGuardarCabecera = true;
      }
      this.spinnerService.activarLoading(false)
    }, err => {
      if(err.url == null){
        this.sinImagenCabecera();
      }
      else{
        this.imagenCabecera = err.url
        this.ocultarBotonEliminarCabecera = false;
        this.ocultarBotonGuardarCabecera = true;
      }
      this.spinnerService.activarLoading(false)
    })
  }

  sinImagenCabecera() {
    this.imagenCabecera = 'assets/img/noimage.png';
    this.ocultarBotonImagenCabecera = true;
    this.ocultarBotonGuardarCabecera = false;
    this.ocultarBotonEliminarCabecera = true;
  }
  
  borrarDatos() {
    this.objUsuarioModel = new objUsuarioModel()
    //Update
    this.correoViewUpdate = '',
    this.claveactualViewUpdate = '',
    this.claveViewUpdate = '',
    this.claveconfirViewUpdate = ''
  }

  guardarModificar() {
    if(!this.validacionCamposNuloVacio()) {
      var dato = ''
      if (this.coduserViewUpdate.trim() == '' || this.coduserViewUpdate == null) {
        dato = '“Código”'
      } else if (this.nombresViewUpdate.trim() == '' || this.nombresViewUpdate == null) {
        dato = '“Nombre y apellido” '
      } else if (this.cargoViewUpdate.trim() == '' || this.cargoViewUpdate == null) {
        dato = '“Cargo” '
      }else if (this.correoViewUpdate?.trim() == '' || this.correoViewUpdate == null) {
        dato = '“Correo” '
      } else if (this.codsucViewUpdate == null || this.codsucViewUpdate <= 0) {
        dato = '"Sucursal"'
      }

      if(dato != ''){
        basicAlert("El campo " + dato + ' es requerido.', 'warning', 'Aceptar');
        return;
      }
    }

    let propiedadesUpdate = new UsuarioPropiedadesFrm();
    propiedadesUpdate.codigoVendedor = this.codvenViewUpdate
    let nuevaclave: string
    if(this.correoViewUpdate?.trim().length <= 0 || !this.validateEmail(this.correoViewUpdate)){
      basicAlert('Por favor, ingresa un correo electrónico válido.','warning','Aceptar');
      return;
    }
    if((this.claveViewUpdate?.trim().length < 8 || !this.validaEstadoContrasenia(this.claveViewUpdate)) && this.modificarclaveViewUpdate){
      basicAlert('Por favor, ingresa una clave válida.','warning','Aceptar');
      return;
    }

    if (this.claveViewUpdate == this.claveconfirViewUpdate) {
      nuevaclave = this.claveconfirViewUpdate
      this.spinnerService.activarLoading(true);
      let usuarioCambio: iusuario = {
        id_cia: 0,
        coduser: this.objUsuarioModel.coduser = this.coduserViewUpdate,
        nombres: this.objUsuarioModel.nombres = this.nombresViewUpdate,
        cargo: this.objUsuarioModel.cargo = this.cargoViewUpdate,
        clave: this.objUsuarioModel.clave = this.claveactualViewUpdate,
        nuevaclave: this.objUsuarioModel.nuevaclave = nuevaclave,
        ruc: '',
        codsuc: this.objUsuarioModel.codsuc = this.codsucViewUpdate,
        atributos: 0,
        fexpira: this.fechaExpiracion,
        fcreac: '',
        factua: '',
        comentario: this.objUsuarioModel.comentario = this.comentarioViewUpdate,
        impeti: 0,
        activo: this.objUsuarioModel.activo = this.activoViewUpdateRespaldo,
        usuari: '',
        numcaja: 0,
        propiedad: this.objUsuarioModel.propiedad = propiedadesUpdate,
        email:this.correoViewUpdate,
        swacti: (this.activoViewUpdateRespaldo)?'S':'N',
        rolId:this.sessionInfo.rolId
      }
      this.usuarioService.actualizar(usuarioCambio).subscribe(response => {
        this.toastr.success('Se modificó correctamente.','',{ positionClass: 'toast-bottom-left'});
        this.spinnerService.activarLoading(false);
        this.cancelarPanel();
      }, err => {
        this.spinnerService.activarLoading(false);
        
        basicAlert_Html(err.error, 'error', 'Aceptar');
      })

    } else {
      basicAlert("Las contraseñas son diferentes.", 'error', 'Aceptar');
      this.claveViewUpdate = ''
      this.claveconfirViewUpdate = ''
    }
  }

  validateEmail(email:string) {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailPattern.test(email)) {
      return false;
    }
    return true;
  }

  cancelar() {
    this.claveactualViewUpdate = '';
    this.claveactualViewUpdate = '';
    this.modificarclaveViewUpdate = false;
    this.estadoVisivilidad = [
      { label: 'NuevaContraseniaInsertar', mostrar: false },
      { label: 'ConfirmarContraseniaInsertar', mostrar: false },
      { label: 'NuevaContraseniaEditar', mostrar: false },
      { label: 'ConfirmarContraseniaEditar', mostrar: false },
      { label: 'ClaveActual', mostrar: false },
    ]
  }

  cancelarPanel(){
    this.modalactiveService.dismiss('canceling');
  }

  /* Firma */
  onChangeFirma(value: number){
    this.tipoItemImageCabecera = value;
    /* this.spinnerService.activarLoading(true); */
    this.obtenerImagen();
  }
  objImagen = new ImagenBase64();
  imageCabecera: any;
  disabledbotonImagenCabecera: boolean = true;
  guardarLogoCabecera() {
    this.objImagen.imagen = this.imageCabecera;
    this.objImagen.formato = 'jpg';
    this.objImagen.tipo = 1;
    this.objImagen.item = this.tipoItemImageCabecera;

    this.spinnerService.activarLoading(true);
    this.usuarioService.actualizarImagenVendedor(this.coduserViewUpdate, this.objImagen).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.fileUploadCabecera.nativeElement.value = "";
      this.disabledbotonImagenCabecera = true;
      basicAlert('Se registró correctamente.', 'success', 'Aceptar')
      this.ocultarBotonGuardarCabecera = true;
      this.ocultarBotonEliminarCabecera = false;
    }, err => {
      if (err.status == 400) {
        this.spinnerService.activarLoading(false);

        console.log(err);
        basicAlert('Debe eliminar el Logo Cabecera actual', 'warning', 'Aceptar');
      } else{
        this.spinnerService.activarLoading(false);
        console.log(err);
        basicAlert(err.error, 'error', 'Aceptar');
      }
    })
  }
  uploadImagenCabecera($event): void {
    this.readThisCabecera($event.target);
  }

  readThisCabecera(inputValue: any): void {
    let imageBase64;
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    this.size = file.size;

    if (this.size <= 1049000) {
      if (file.type == 'image/jpeg') {
        myReader.onloadend = (e) => {
          imageBase64 = myReader.result;
          this.imagenCabecera = this._sanitizer.bypassSecurityTrustResourceUrl(imageBase64);
          this.imageCabecera = imageBase64.replace("data:image/jpeg;base64,", "");
        }
        myReader.readAsDataURL(file);
        this.disabledbotonImagenCabecera = false;
      }
      else {
        // this.funicionesTSIService.alertSweet('Debe seleccionar una imagen con formato .JPG', 'warning');
        this.disabledbotonImagenCabecera = true;
        this.fileUploadCabecera.nativeElement.value = "";
        return;
      }
    } else {
      // this.funicionesTSIService.alertSweet('El tamaño de la imagen excedio el limite permitido de 1Mb', 'warning');
      this.disabledbotonImagenCabecera = true;
      this.fileUploadCabecera.nativeElement.value = "";
      return;
    }
  }
  deleteLogoCabecera() {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true).then((responseAlert) => {
      if (responseAlert) {
        this.spinnerService.activarLoading(true)
        this.usuarioService.deleteImagenVendedor(this.coduserViewUpdate,this.tipoItemImageCabecera).subscribe((response: any) => {
          this.fileUploadCabecera.nativeElement.value = "";
          basicAlert('Se eliminó correctamente.', 'success', 'Aceptar')
          this.imagenCabecera = '';
          this.spinnerService.activarLoading(false)
          this.ocultarBotonImagenCabecera = false;
         
        }, err => {
          console.log(err);
          if (err.status == 410) {
            basicAlert(err.error, 'warning', 'Aceptar')
            this.spinnerService.activarLoading(false)
          }
          if (err.status == 404) {
            basicAlert(err.error, 'warning', 'Aceptar')
            this.spinnerService.activarLoading(false)
          }
          if(err.status == 500){
            basicAlert(err.error, 'warning', 'Aceptar')
            this.spinnerService.activarLoading(false)
          }
        })

      }
    })
  }

  cambioEstadoModificarClave() {
    if (this.modificarclaveViewUpdate) {
      this.fechaExpiracion = this.formatearFecha(new Date());
    } else {
      this.fechaExpiracion = '';
      this.claveViewUpdate = '';
      this.claveconfirViewUpdate = '';
      this.claveactualViewUpdate = '';
    }
  }

  formatearFecha(fecha: Date): string {
    fecha.setFullYear(fecha.getFullYear() + 1);
    const dia = ('0' + fecha.getDate()).slice(-2);
    const mes = ('0' + (fecha.getMonth() + 1)).slice(-2);
    const año = fecha.getFullYear();
    return `${año}-${mes}-${dia}`;
  }

  validaEstadoContrasenia(cadena: string): boolean {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(cadena);
  }

  validarRequisitosContrasena(clave: string) {
    this.requisitosContrasena.longitud = clave.length >= 8;
    this.requisitosContrasena.minuscula = /[a-z]/.test(clave);
    this.requisitosContrasena.mayuscula = /[A-Z]/.test(clave);
    this.requisitosContrasena.numero = /\d/.test(clave);
    this.requisitosContrasena.especial = /[!@#$%^&*()_+\-=\]{};':"\\|,.<>?]/.test(clave);
    this.requisitosContrasena.igualdad = this.claveViewUpdate === this.claveconfirViewUpdate;
    this.empezarEscribir = clave.length > 0;
  }
  estiloValidacion(cadena: string = "", tipo?: string, esNuevo: boolean = false) {
    if (!this.modificarclaveViewUpdate && tipo === "contrasenia" && !esNuevo) {
        return '';
    }

    if (cadena == "" || cadena == null) {
        return '';
    }

    switch (tipo) {
        case 'contrasenia':
            this.validarRequisitosContrasena(cadena); 
            return (this.requisitosContrasena.longitud && 
                    this.requisitosContrasena.minuscula && 
                    this.requisitosContrasena.mayuscula && 
                    this.requisitosContrasena.numero && 
                    this.requisitosContrasena.especial&& 
                    this.requisitosContrasena.igualdad)
                    ? 'success-validation-border'
                    : 'error-validation-border';
                    
        case 'confirmarContrasenia':
            this.requisitosContrasena.igualdad = this.claveViewUpdate === this.claveconfirViewUpdate;
            return this.requisitosContrasena.igualdad
                    ? 'success-validation-border'
                    : 'error-validation-border';
        
        case 'correo':
            return (this.validateEmail(cadena))
                    ? 'success-validation-border'
                    : 'error-validation-border';

        default:
            return '';
    }
}
  toggleMostrarContrasena(indice:number): void {
    this.estadoVisivilidad[indice].mostrar = !this.estadoVisivilidad[indice].mostrar;
  }

  validacionCamposNuloVacio(): boolean {
    return this.areaCadenaVacioNulo(
        this.coduserViewUpdate,
        this.nombresViewUpdate,
        this.cargoViewUpdate,
        this.correoViewUpdate
      ) && this.noEsNulOIndefinido(this.codsucViewUpdate) && this.codsucViewUpdate! >= 0;
  }

  private esCadenaVacioNulo(value: string | undefined): boolean {
    return value != null && value.trim().length > 0;
  }

  private areaCadenaVacioNulo(...values: (string | undefined)[]): boolean {
    return values.every(this.esCadenaVacioNulo);
  }

  private noEsNulOIndefinido(value: any): boolean {
    return value != null;
  }
}
